<template>
	<div>
		<app-table
			class="is-not-selectable"
			name="dictionary"
			:columns="columns"
			:current-page="currentPage"
			:last-page="lastPage"
			:rows="rows"
			@on-search-event="$emit('on-search', $event)"
			@on-page="$emit('on-page', $event)"
		>
			<template slot="rows" slot-scope="props">
				<td class="is-not-selectable col-1">
					{{ props.row.code }}
				</td>
				<td class="col-2">
					{{ props.row.name }}
				</td>
				<td class="col-3">
					{{ props.row.description }}
				</td>
				<td class="col-4">
					{{ props.row.example }}
				</td>
				<td class="col-5">
					<app-tooltip-button
						class="no-movil"
						color="success"
						:disabled="disabledButtons"
						img="/static/img/icons/edit.svg"
						text="Editar"
						@click-icon="$emit('click-icon', { action: 'edit', row: props.row })"
					/>
					<app-tooltip-button
						color="error"
						class="no-movil"
						:disabled="disabledButtons"
						img="/static/img/actions-list/delete.svg"
						text="Eliminar"
						@click-icon="$emit('click-icon', { action: 'delete', row: props.row })"
					/>
					<div class="collapse-menu">
						<v-menu>
							<v-btn dark icon slot="activator">
								<v-icon>more_horiz</v-icon>
							</v-btn>
							<v-list>
								<v-list-tile class="btn-menu-content">
									<v-list-tile-title
										class="menu-content"
										:disabled="disabledButtons"
										@click="$emit('click-icon', { action: 'edit', row: props.row })">
										<img
										src="/static/img/icons/edit.svg"
										alt="edit"
										class="menu-option-icon"
										width="15px"
										height="15px"
										>
										<span class="ml-1 edit">Editar</span>
									</v-list-tile-title>
								</v-list-tile>
								<v-list-tile class="btn-menu-content">
									<v-list-tile
										class="menu-content"
										:disabled="disabledButtons"
										@click="$emit('click-icon', { action: 'delete', row: props.row })">
										<img
										src="/static/img/actions-list/delete.svg"
										alt="delete"
										class="menu-option-icon"
										width="15px"
										height="15px"
										>
										<span class="ml-1">Eliminar</span>
									</v-list-tile>
								</v-list-tile>
							</v-list>
						</v-menu>
					</div>
				</td>
			</template>
		</app-table>
	</div>
</template>

<script>
import appTooltipButton from '@/components/shared/app-tooltip-button';

function disabledButtons() {
	const userI = typeof this.$userInfo === 'string' ? JSON.parse(this.$userInfo) : this.$userInfo;
	const notFranchise = userI && (userI.company.franchise === null || userI.company.franchise === 0);
	const fatherFranchise = userI && userI.company
		&& userI.company.franchise
		&& userI.subsidiary.father
		? userI.company.franchise === 1 && userI.subsidiary.father === 1 : false;
	return !notFranchise && !fatherFranchise;
}

function data() {
	return {
		columns: [
			{ id: 1, name: 'Código', value: 'code', checked: true, visible: true, movil: true },
			{ id: 2, name: 'Nombre', value: 'name', checked: true, visible: true },
			{ id: 3, name: 'Descripción', value: 'description', checked: true, visible: true, movil: true },
			{ id: 4, name: 'Data de Ejemplo', value: 'example', checked: true, visible: true, movil: true },
			{ id: 5, name: 'Acciones', checked: true, visible: true, flagVisible: true },
		],
	};
}

export default {
	name: 'dictionary-list',
	components: {
		appTooltipButton,
	},
	data,
	computed: {
		disabledButtons,
	},
	props: {
		currentPage: {
			default: 1,
			type: Number,
		},
		lastPage: {
			type: Number,
			default: 1,
		},
		rows: {
			type: Array,
			default: () => [],
		},
	},
};
</script>

<style lang="scss">
.col-1 {
	@media (max-width: 768px) {
		background-color: color(grey-background);
		display: grid;
		grid-column: 1/4;
		grid-row: 1;
		padding-left: 33px !important;
		text-align: left !important;
		white-space: nowrap;
	}
}

.col-2 {
	@media (max-width: 768px) {
		border-top: 1px solid color(grey-background);
		display: grid;
		grid-column: 1/2;
		grid-row: 2;
		line-height: 32px;
	}
}

.col-3 {
	@media (max-width: 768px) {
		display: grid;
		grid-column: 2/4;
		grid-row: 2;
		text-align: center !important;
	}
}

.col-4 {
	@media (max-width: 768px) {
		border-top: 1px solid color(grey-background);
		display: grid;
		grid-column: 4/5;
		grid-row: 2;
		padding-top: 7px;
		text-align: center !important;
	}
}

.col-5 {
	@media (max-width: 800px) {
		background-color: color(grey-background);
		display: grid;
		grid-column: 4/5;
		grid-row: 1;
		justify-content: center;
	}
}

.collapse-menu {
	display: none;

	@media (max-width: 780px) {
		align-items: center;
		display: block;
		height: 100%;
		justify-content: center;
	}

		.v-menu {
		align-items: center;
		display: flex;
		height: 100%;
		justify-content: center;

		.v-btn {
			background-color: color(btn-green);
			height: 25px;
			margin: 0;
			width: 25px;
		}
	}
}

	.menu-content {
		align-items: center;
		color: color(red-icon);
		display: grid;
		font-family: font(AvenirRegular);
		font-size: size(small) !important;
		grid-column-gap: 3px;
		grid-template-columns: 15px 1fr;
		width: 175px;

		.factory {
			color: color(secondary);
		}

		.edit {
			color: color(btn-green);
		}
	}

	.btn-menu-content {
		border-bottom: 1px solid color(grey-background-table);
	}
</style>



// WEBPACK FOOTER //
// src/components/dictionary/dictionary-list.vue